package dev.lingvo.ops.state

import dev.lingvo.shared.ops.OpsWebhookRowDto

enum class OpsWebhookRisk { FAILING, UNSIGNED, QUIET, HEALTHY }

fun webhookRisk(row: OpsWebhookRowDto): OpsWebhookRisk = when {
    row.consecutiveFailures > 0 -> OpsWebhookRisk.FAILING
    !row.signed -> OpsWebhookRisk.UNSIGNED
    row.lastAttemptAt == null -> OpsWebhookRisk.QUIET
    else -> OpsWebhookRisk.HEALTHY
}

fun webhookRiskOrder(rows: List<OpsWebhookRowDto>): List<OpsWebhookRowDto> = rows.sortedBy {
    when (webhookRisk(it)) {
        OpsWebhookRisk.FAILING -> 0
        OpsWebhookRisk.UNSIGNED -> 1
        OpsWebhookRisk.QUIET -> 2
        OpsWebhookRisk.HEALTHY -> 3
    }
}
